import { BROWSER_DETAILS_KEY } from './reducers';

export const getBrowserUnsupported = state =>
    getBrowserOldVersion(state) || getBrowserMissingFeature(state);

export const getBrowserPlatform = state => state.getIn([BROWSER_DETAILS_KEY, 'platform']);

export const getBrowserOldVersion = state => state.getIn([BROWSER_DETAILS_KEY, 'oldVersion']);

export const getBrowserMissingFeature = state =>
    state.getIn([BROWSER_DETAILS_KEY, 'missingFeature']);

export const getBrowserSupportsFetch = state => state.getIn([BROWSER_DETAILS_KEY, 'supportsFetch']);

export const getBrowserAnimationBroken = state =>
    state.getIn([BROWSER_DETAILS_KEY, 'animationBroken']);

export const isBrowserInternetExplorer = state =>
    state.getIn([BROWSER_DETAILS_KEY, 'browserIsInternetExplorer']);

export const getBrowserDetails = state => state.getIn([BROWSER_DETAILS_KEY, 'browserDetails']);

export const getBrowserDetailsLabel = state =>
    state.getIn([BROWSER_DETAILS_KEY, 'browserDetails', 'label']);
